import axios from 'axios';
import authHeader from './AuthHeader';
import { AppConstants } from '../constants/AppConstants';
import JobEntity from "../types/jobEntity.type";

class JobsService {

  getUserJob(userId: number) {
      return axios.get(AppConstants.API_URL + '/jobs/' + userId, { headers: authHeader() });
  }


  getJobsBoard() {
    return axios.get(AppConstants.API_URL + '/jobs/all-jobs', { headers: authHeader() });
  }

  deleteJob(jobId: number) {
    return axios.delete(AppConstants.API_URL + '/jobs/'+ jobId, { headers: authHeader() });
  }
  updateJob(jobEnitity: JobEntity) {
    if (jobEnitity.id == null) throw new Error("Job ID is required");
    return axios.put(AppConstants.API_URL + '/jobs/' + jobEnitity.id, jobEnitity, {
      headers: authHeader(),
    });
  }
}

export default new JobsService();